export const CRON_EXECUTED = 'CRON_EXECUTED';
